import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  game_list: [],
  all_game_list: [],
  selectGame: '',
};

const gameStateSlice = createSlice({
  name: 'game',
  initialState: initialState,
  reducers: {
    listGame: (state, action) => {
      state.game_list = [...action.payload]
    },
    resetListGame: (state, action) => {
      state.game_list = []
    },
    allGameList: (state, action) => {
      state.all_game_list = [...action.payload]
    },
    selectGame: (state, action) => {
      state.selectGame = action.payload;
    },
  }
});

export const { listGame, resetListGame, allGameList, selectGame } = gameStateSlice.actions;

export default gameStateSlice.reducer;